/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenRecipeModalCreateMutationVariables = {|
  allergen: string,
  recipe: string,
|};
export type AllergenRecipeModalCreateMutationResponse = {|
  +recipeAddAllergen: ?{|
    +recipeAllergen: ?{|
      +id: string,
      +allergen: {|
        +id: string,
        +name: string,
        +icon: ?string,
      |},
    |}
  |}
|};
export type AllergenRecipeModalCreateMutation = {|
  variables: AllergenRecipeModalCreateMutationVariables,
  response: AllergenRecipeModalCreateMutationResponse,
|};
*/


/*
mutation AllergenRecipeModalCreateMutation(
  $allergen: ID!
  $recipe: ID!
) {
  recipeAddAllergen(input: {allergen: $allergen, recipe: $recipe}) {
    recipeAllergen {
      id
      allergen {
        id
        name
        icon
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "allergen",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipe",
    "type": "ID!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "allergen",
            "variableName": "allergen"
          },
          {
            "kind": "Variable",
            "name": "recipe",
            "variableName": "recipe"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeAddAllergenPayload",
    "kind": "LinkedField",
    "name": "recipeAddAllergen",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeAllergenNode",
        "kind": "LinkedField",
        "name": "recipeAllergen",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AllergenNode",
            "kind": "LinkedField",
            "name": "allergen",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenRecipeModalCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenRecipeModalCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenRecipeModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenRecipeModalCreateMutation(\n  $allergen: ID!\n  $recipe: ID!\n) {\n  recipeAddAllergen(input: {allergen: $allergen, recipe: $recipe}) {\n    recipeAllergen {\n      id\n      allergen {\n        id\n        name\n        icon\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab685dab3d73e6101f100ce1c7720b03';

module.exports = node;
